import CampaignPartial from "../../partials/campaign/campaign.partial";

export default function CampaignScreen() {
  return <CampaignPartial />;
}
